import { inject, Inject, Injectable, Optional } from '@angular/core';
import { App } from '@df/core/app';
import { CookiesService } from '@df/core/service/cookies';
import { isPwaStandalonForced } from '@df/module-pwa/pwa-const';
import { PwaIntegrationService } from '@df/module-pwa/pwa-integration.service';
import { NPwa } from '@df/module-pwa/pwa.interface';
import { PWA_OPTIONS } from '@df/module-pwa/pwa.options';
import { TimeoutService } from '@df/ng/timeout.service';
import { BodyClassService } from '@df/ui/body-class.service';
import { LocalGtmService } from '../gtm/gtm.service.decorator';

@Injectable({
    providedIn: 'root'
})
export class LocalPwaIntegrationService extends PwaIntegrationService {
    override isStandalone = isPwaStandalonForced;
    private gtmService = inject(LocalGtmService);

    constructor(
        app: App,
        cookieService: CookiesService,
        timeoutService: TimeoutService,
        bodyClassService: BodyClassService,
        @Optional() @Inject(PWA_OPTIONS) options: NPwa.IModuleOptions
    ) {
        super(app, cookieService, timeoutService, bodyClassService, options);

        if (app.isPlatformBrowser) {
            this.trackAppView();
        }
    }

    /**
     * Push standalone status to GTM data layer
     */
    private trackAppView(): void {
        if (this.isStandalone) {
            const eventData = {
                event: 'inAppView',
                isApp: 1
            };

            this.gtmService.push(eventData);
        }
    }
}
